var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"divide-y divide-gray-200"},[_c('change-password'),_c('active-sessions')],1)}
var staticRenderFns = []

export { render, staticRenderFns }